import { render, staticRenderFns } from "./patentIndicator.vue?vue&type=template&id=9d538858&"
import script from "./patentIndicator.vue?vue&type=script&lang=js&"
export * from "./patentIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports